// Lazy wrapper around sql-formatter. The library is ~150 KB gzipped, so
// we only pay the bundle cost the first time the user reaches for Format.
// Cached after first import — subsequent calls are sync as far as the
// network is concerned (the import promise resolves from the module cache).

let formatterPromise: Promise<typeof import('sql-formatter')> | null = null;

async function loadFormatter(): Promise<typeof import('sql-formatter')> {
  if (!formatterPromise) {
    formatterPromise = import('sql-formatter');
  }
  return formatterPromise;
}

export interface FormatOptions {
  /** Indent width in spaces. Defaults to 2 to match the editor's tab insert. */
  tabWidth?: number;
  /** Force keywords to a specific case. "preserve" keeps user's casing. */
  keywordCase?: 'upper' | 'lower' | 'preserve';
}

const DEFAULTS: Required<FormatOptions> = {
  tabWidth: 2,
  keywordCase: 'upper',
};

export async function formatSql(sql: string, opts: FormatOptions = {}): Promise<string> {
  const merged = { ...DEFAULTS, ...opts };
  const { format } = await loadFormatter();
  return format(sql, {
    language: 'sqlite',
    tabWidth: merged.tabWidth,
    keywordCase: merged.keywordCase,
  });
}
